<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">Produk Saya</h5>
      <template v-if="!products.items == ''">
        <!-- Button trigger modal -->
        <router-link
          to="/product/addproduct"
          class="btn btn-primary pull-right"
        >
          Tambah Produk
        </router-link>
        <button
          id="filterCollapse"
          :class="arrow === 0 ? 'btn btn-filter' : 'btn btn-filter active'"
          type="button"
          data-toggle="collapse"
          data-target="#collapseFilter"
          aria-expanded="false"
          aria-controls="collapseFilter"
          @click="arrowChanger"
        >
          <span style="color: #414141">
            Filters
            <i
              :class="
                arrow === 0 ? 'ml-2 fa fa-caret-down' : 'ml-2 fa fa-caret-up'
              "
              aria-hidden="true"
            ></i>
          </span>
        </button>
        <div class="collapse show" id="collapseFilter">
          <div class="row">
            <div class="col-lg">
              <vue-select
                class="ml-3 mt-1"
                :options="keyword"
                v-model="jenisCari"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Pilih Jenis..."
                :clearable="clearable"
              />
              <div class="select-filter-icon">
                <i class="fa fa-bars"></i>
              </div>
            </div>

            <div class="col-lg">
              <input
                class="input-filter"
                id="nameFilter"
                v-model="keyFilter"
                name="nameFilter"
                type="text"
                placeholder="Cari..."
              />
            </div>

            <div class="col-lg">
              <select
                name=""
                class="select-filter"
                id="categoryFilter"
                v-model="categoryFilter"
              >
                <option value="" selected>Semua Kategori</option>
                <template v-for="ct in category">
                  <option
                    :key="ct.name"
                    :class="
                      ct.name === 'Perlu Update'
                        ? 'bg-soft-danger text-white'
                        : ''
                    "
                    :value="ct.value"
                  >
                    {{ ct.name }} ({{ ct.total }})
                  </option>
                  <option
                    v-for="res in ct.children"
                    :key="res.name"
                    :value="res.value"
                  >
                    <span>&#9913;</span> {{ res.name }} ({{ res.total }})
                  </option>
                </template>
              </select>
              <div class="select-filter-icon">
                <i class="fa fa-th-large"></i>
              </div>
            </div>

            <div class="col-lg">
              <vue-select
                class="ml-3 mt-1"
                :options="status"
                v-model="statusFilter"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Filter Status Pesanan..."
                :clearable="clearable"
              />
              <div class="select-filter-icon">
                <i class="fa fa-toggle-on" aria-hidden="true"></i>
              </div>
            </div>

            <div class="col-lg mb-5">
              <vue-select
                class="ml-3 mt-1"
                :options="limitData"
                v-model="limitFilter"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Filter Status Pesanan..."
                :clearable="clearable"
              />
              <div class="select-filter-icon">
                <i class="fa fa-th-list" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </template>
      <UpdateCategoryMassal
        v-if="categoryFilter == 0 && !categoryFilter == ''"
        :oldCategories="oldCategories"
        :selectedOldCat="selectedOldCat"
        :oldCat="oldCat"
        :renderComponent="renderComponent"
        :resetForm="resetForm"
        :massalUpdateCategory="massalUpdateCategory"
      />
    </div>

    <div class="col-lg-2 float-right mb-5" v-if="!products.items == ''">
      <input
        class="input-filter"
        id="nameFilter"
        v-model="searchGlobal"
        name="nameFilter"
        type="text"
        placeholder="Search..."
      />
      <div class="input-filter-icon">
        <i class="fa fa-search mr-2"></i><span style="font-size: 12px"></span>
      </div>
    </div>

    <div class="resetFilter col-lg-2 mb-3">
      <button
        class="btn btn-secondary btn-sm btn-circle"
        id="resetFilter"
        @click="resetFilter"
      >
        <i
          id="resetIcon"
          class="now-ui-icons arrows-1_refresh-69"
          aria-hidden="true"
          style="font-size: 15px"
        ></i>
      </button>
    </div>

    <div class="card-body">
      <ModalDetail></ModalDetail>
      <ModalPicture></ModalPicture>
      <TableLoader />
      <div
        v-if="
          categoryFilter == 0 && !categoryFilter == '' && selectedOldCat != ''
        "
        class="row sticky-top"
      >
        <div
          :class="
            choosedProducts.length != 0
              ? 'alert alert-info text-center p-3 custom-block w-100'
              : 'alert bg-soft-danger text-center p-3 custom-block w-100'
          "
          id="notif"
        >
          <span class="text-center">
            <i class="fa fa-paperclip" aria-hidden="true"> </i>
            <span class="ml-2 text-center"
              >Anda memilih {{ choosedProducts.length }} produk</span
            >
          </span>
          <br />
          <!-- <a class="mb-0 ml-4"><u class="">Lihat produk</u></a> -->
        </div>
      </div>
      <div class="table-responsive">
        <div class="col-sm-12">
          <table
            class="table table-condensed text-center table-hover"
            width="100%"
          >
            <thead>
              <tr class="table-condensed text-sm-center">
                <th v-if="categoryFilter == 0 && !categoryFilter == ''">
                  Pilih
                </th>
                <th
                  id="filterSort"
                  v-for="col in column"
                  @click="col.value == '' ? sort('') : sort(col.value)"
                  :key="col.name"
                  style="cursor: pointer"
                >
                  {{ col.name }}
                  <template v-if="col.isOrder">
                    <template v-if="col.order === ''">
                      <i class="up-icon" />
                      <i class="down-icon" />
                    </template>
                    <template v-else>
                      <i
                        :class="[
                          col.order === 'desc' ? 'up-icon' : 'down-icon',
                        ]"
                      />
                    </template>
                  </template>
                  <!-- <i v-if="col.isOrder" style="font-size:9px"
                  :class="[col.order === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down']"/> -->
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="products.items == ''">
                <td class="table-secondary" :colspan="column.length">
                  No Data Found
                </td>
              </tr>
              <tr
                :class="product.isBlocked ? 'bg-secondary' : ''"
                v-for="product in products.items"
                :key="product.id"
              >
                <transition name="component-fade" mode="out-in">
                  <td
                    v-if="
                      categoryFilter == 0 &&
                        !categoryFilter == '' &&
                        selectedOldCat != ''
                    "
                  >
                    <input
                      type="checkbox"
                      :value="Number(product.id)"
                      v-model="choosedProducts"
                    />
                  </td>
                </transition>
                <td width="50" class="text-center">{{ product.no }}</td>
                <td v-if="product.isBlocked">
                  <span class="badge badge-soft-danger">Blocked</span>
                </td>
                <td v-else-if="product.isWaitingConfirm">
                  <span class="badge badge-soft-warning">Waiting Approve</span>
                </td>
                <td v-else>
                  <input
                    class="toggle_table"
                    type="checkbox"
                    data-toggle="toggle"
                    :data_id="product.id"
                    :data_name="product.name"
                    :checked="product.isActive"
                    data-on=" "
                    data-off=" "
                    data-onstyle="warning"
                    data-style="ios"
                    data-width="10"
                    data-height="10"
                  />
                </td>
                <td width="10%">
                  <div class="pictureFrame">
                    <div class="placeholder-item zoom-gallery">
                      <a :href="product.image" :title="product.name">
                        <img :src="product.image" width="80%" />
                      </a>
                    </div>
                  </div>
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  <p class="text-wrap text-left">
                    {{ product.name }}
                    <br />
                    <span
                      v-if="product.badges.includes('package')"
                      class="badge badge-soft-info"
                      >Paket</span
                    >
                    <!-- <span v-if="product.badges.includes('jasa')" class="badge badge-soft-info">Jasa</span> -->
                  </p>
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                  :class="product.model == '' ? 'text-muted' : ''"
                >
                  {{ product.model == "" ? "None" : product.model }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  {{ product.price }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  {{ product.priceZone1 }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  {{ product.priceZone2 }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  {{ product.priceZone3 }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  {{ product.priceZone4 }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                >
                  {{ product.priceZone5 }}
                </td>
                <td
                  @click="eventDetail(product.id, product.isBlocked)"
                  style="cursor: pointer"
                  class="text-capitalize"
                >
                  {{ product.ppnType }}
                </td>
                <td
                  :class="
                    product.stock == 0 || product.stock.includes('-')
                      ? 'badge-soft-danger'
                      : ''
                  "
                >
                  <span
                    class="badge badge-soft-success"
                    v-if="
                      product.stock == 100000000 &&
                        product.name.includes('Jasa') &&
                        product.isLayout == 3
                    "
                  >
                    Jasa
                  </span>
                  <span
                    :class="
                      product.stock == 0 || product.stock.includes('-')
                        ? 'badge badge-soft-danger '
                        : ''
                    "
                    v-else
                  >
                    {{ product.stock }}
                  </span>
                </td>
                <td
                  v-if="product.category === 'Uncategorized'"
                  class="text-danger"
                >
                  <div
                    class="bg-soft- p-2 rounded"
                    data-toggle="modal"
                    data-target="#editCategory"
                    @click="editCategory(product)"
                    style="cursor: pointer"
                  >
                    <span
                      class="badge badge-soft-danger text-danger"
                      data-toggle="modal"
                      data-target="#editCategory"
                      @click="editCategory(product)"
                    >
                      Perlu Update
                    </span>
                    <br />
                    <button
                      class="btn btn-outline-default bg-transparent btn-sm mt-2"
                      type="button"
                      data-toggle="modal"
                      data-target="#editCategory"
                      style="border: 0px"
                      @click="editCategory(product)"
                    >
                      <i
                        style="font-size: 14px"
                        class="text-dark far fa-edit"
                      ></i>
                    </button>
                  </div>
                  <ModalEditCategory
                    :editState="editState"
                    :listCategory="listCategory"
                    :listSubCategory="listSubCategory"
                    :listSub2Category="listSub2Category"
                    :getCategoryVal="getCategoryVal"
                    :getSubCategoryVal="getSubCategoryVal"
                    :lastCategoryBarang="lastCategoryBarang"
                    :listCategoryJasa="listCategoryJasa"
                    :getCategoryValJasa="getCategoryValJasa"
                    :listSubCategoryJasa="listSubCategoryJasa"
                    :lastCategoryJasa="lastCategoryJasa"
                    :saveEditCategory="saveEditCategory"
                    :disabledEditCategoryNonBook="disabledEditCategoryNonBook"
                  >
                  </ModalEditCategory>
                </td>
                <td v-else>
                  <span class="text-wrap">
                    {{ product.category }}
                  </span>
                </td>

                <td v-if="!product.isBlocked">
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#detailModal"
                    @click="detailModalOpen(product)"
                    class="btn btn-outline-default bg-transparent btn-sm"
                    style="width: 20px; border: 0px"
                  >
                    <i class="fas fa-expand"></i>
                  </button>
                  <router-link
                    :to="'/product/detail/' + product.id"
                    class="btn btn-outline-default bg-transparent btn-sm"
                    style="width: 20px; border: 0px"
                  >
                    <i class="fas fa-pencil-alt"></i
                  ></router-link>
                  <button
                    class="btn btn-outline-default bg-transparent btn-sm"
                    style="width: 20px; border: 0px"
                    @click="
                      deleteProduct(product.id, product.name, product.image)
                    "
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
                <td v-else>
                  <i class="fas fa-ban text-muted"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <Loading /> -->
      </div>
      <div class="row">
        <div class="col">
          <p class="text-muted mt-1 ml-4 pull-left">
            Showing {{ products.from }} to {{ products.to }} of
            {{ products.total }} entries
          </p>
        </div>
        <div class="col" v-if="productsPagination.last_page > 1">
          <!-- {{productsPagination}} -->
          <!-- <pagination
            :data="productsPagination"
            @pagination-change-page="onPaginate"
            :align="align"
            :limit="limit"
            :showDisabled="showDisabled"
          ></pagination> -->
          <paginate
            class="float-right mr-3"
            :pageCount="productsPagination.last_page"
            :containerClass="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            :active-class="'active'"
            v-model="currentPage"
            :clickHandler="onPaginate"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.modal-content {
  background-color: rgb(245, 245, 245);
}
</style>

<script>
import axios from "axios";
import TableLoader from "/src/components/loader/TableLoader.vue";
import $ from "jquery";
import ModalPicture from "../modal/modalPicture.vue";
import ModalDetail from "../modal/modalDetailProduct.vue";
import ModalEditCategory from "../../seller/modal/ModalEditCategory.vue";
import UpdateCategoryMassal from "./UpdateCategoryMassal.vue";
// import Loading from "/src/components/loader/Loading.vue";
import Vue from "vue";
import VueSelect from "vue-select";
import { imagePopup } from "/src/utils/imagePopup.js";
import { sleeper } from "/src/utils/sleeper.js";
import "@fortawesome/fontawesome-free/css/all.css";

import VuejsPaginate from "vuejs-paginate";
Vue.component("paginate", VuejsPaginate);

export default {
  components: {
    ModalPicture,
    ModalDetail,
    ModalEditCategory,
    TableLoader,
    VueSelect,
    UpdateCategoryMassal,
    // Loading,
  },
  data() {
    return {
      limitData: [
        {
          name: 5,
          value: 5,
        },
        {
          name: 10,
          value: 10,
        },
        {
          name: 25,
          value: 25,
        },
        {
          name: 50,
          value: 50,
        },
        {
          name: 100,
          value: 100,
        },
      ],
      multiple: true,
      keyword: {},
      category: {},
      subCategory: {},
      status: {},
      column: {},
      currentPage: 1,
      limitFilter: 5,
      statusFilter: "",
      categoryFilter: "",
      jenisCari: "",
      keyFilter: "",
      currentSort: "",
      currentSortDir: "", // pake - biar berfungsi
      searchGlobal: "",
      products: {
        from: 0,
        to: 0,
        total: 0,
      },
      productsPagination: {},
      limit: 4,
      showDisabled: true,
      align: "right",
      arrow: 0,
      clearable: false,
      centerOfFilter: "",
      editState: {},
      listSubCategory: Array,
      listSub2Category: Array,
      listCategory: [],
      catVal: 0,
      subCatVal: 0,
      listCategoryJasa: [],
      listSubCategoryJasa: [],
      catValJasa: 0,
      disabledEditCategoryNonBook: true,
      oldCategories: [],
      selectedOldCat: "",
      renderComponent: true,
      choosedProducts: [],
    };
  },
  watch: {
    limitFilter() {
      this.getAndPutResult(1);
      this.smoothScroll();
    },
    statusFilter() {
      this.getAndPutResult(1);
      this.smoothScroll();
    },
    categoryFilter() {
      this.getAndPutResult(1);
      this.smoothScroll();
    },
    jenisCari() {
      this.getAndPutResult(
        typeof this.currentPage !== "undefined" ? this.currentPage : 1
      );
      this.smoothScroll();
    },
    keyFilter() {
      this.getAndPutResult(1);
      this.smoothScroll();
    },
    currentSortDir() {
      this.getAndPutResult(1);
      this.smoothScroll();
    },
    searchGlobal() {
      this.getAndPutResult(1);
      this.smoothScroll();
    },
    catVal() {
      this.getSubCategory();
    },
    subCatVal() {
      this.getSub2Category();
    },
    catValJasa() {
      this.getSubCategoryJasa();
    },
  },
  created() {
    this.getAndPutResult(Number(this.$route.query.page) || 1);
    this.getBarangCategory();
    this.getSubCategory();
    this.getSub2Category();
  },
  beforeRouteUpdate(to, from, next) {
    this.getAndPutResult(to.query.page);
    next();
  },
  updated() {
    this.editStatus();
    if (this.listSubCategoryJasa.length === 0) {
      let textSelect = $("#jasaCategory option:selected").text();
      // let valSelect = $("#jasaCategory").val();
      $("#resultJasaCategory").html(
        `<span class="text-dark"><strong>${textSelect}</strong></span>`
      );
      $("#jasaSubCategory").addClass("d-none");
    } else if (this.listSubCategoryJasa.length === 1) {
      let textSelect = $("#jasaSubCategory option:selected").text();
      // let valSelect = $("#jasaSubCategory").val();

      $("#resultJasaCategory").html(
        `<span class="text-dark"><strong>${textSelect}</strong></span>`
      );
      $("#jasaSubCategory").removeClass("d-none");
      $("#jasaSubCategory").removeClass("is-invalid");
    } else {
      $("#jasaSubCategory").removeClass("d-none");
      $("#jasaSubCategory").addClass("is-invalid");
      $("#resultJasaCategory").html(
        "<span class='text-danger'>Pilih Kategori</span>"
      );
    }

    if (this.listSub2Category.length === 0) {
      $("#nonBookSub2Category").addClass("d-none");
    } else {
      $("#resultBarangCategory").html(
        "<span class='text-danger'>Pilih Kategori</span>"
      );
    }
  },
  async mounted() {
    await this.$nextTick();
    this.getSubCategory();
    this.getBarangCategory();
    this.getJasaCategory();
    this.getSubCategoryJasa();
  },
  methods: {
    eventDetail(id, isBlocked) {
      if (!isBlocked) {
        this.$router.push(`/product/detail/${id}`);
      }
    },
    oldCat() {
      $("#oldCategories").removeClass("is-invalid");
      this.selectedOldCat = $("#oldCategories").val();
      setTimeout(() => {
        this.getAndPutResult(1);
      }, 200);
    },
    editStatus() {
      const globalThis = this;
      $(".toggle_table").on("change", function() {
        const productId = $(this).attr("data_id");
        let productName = $(this).attr("data_name");
        // console.log(productId);
        axios
          .put("seller/product/status", {
            id: productId,
          })
          .then((res) => {
            const status = res.data.data;
            status === 1
              ? globalThis.$toast.success(
                  `Status Produk ${productName} Menjadi Aktif`
                )
              : globalThis.$toast.error(
                  `Status Produk ${productName} Menjadi Tidak Aktif`
                );
          })
          .then(sleeper(300))
          .then(() => {
            $(".toggle_table").bootstrapToggle();
          });
      });
    },
    editCategory(product) {
      this.disabledEditCategoryNonBook = true;
      this.editState = product;
    },
    saveEditCategory(productId, catId) {
      catId =
        $("#nonBookSub2Category").val() === null
          ? $("#nonBookSubCategory").val()
          : $("#nonBookSub2Category").val();
      // console.log(productId, catId)
      axios
        .put("seller/product/category", {
          productId: productId,
          categoryId: Number(catId),
        })
        .then((res) => {
          $("#editCategory").modal("hide");
          return res.data.status;
        })
        .then((status) => {
          status.code == 404
            ? this.$toast.error("Edit Kategori Gagal")
            : this.$toast.success("Edit Kategori Berhasil");
          this.getAndPutResult(Number(this.$route.query.page) || 1);
        });
    },
    massalUpdateCategory() {
      let subCat2 = $("#nonBookSub2CategoryMassal").children("option").length;
      let valNewCat =
        subCat2 === 0
          ? $("#nonBookSubCategoryMassal option:selected").val()
          : $("#nonBookSub2CategoryMassal option:selected").val();
      if ($("#oldCategories").hasClass("is-invalid")) {
        this.$toast.error("Pilih Kategori lama terlebih dahulu");
      } else {
        const textChoosenOldCat = $("#oldCategories option:selected")
          .text()
          .split(" (")[0];
        const textChoosenNewCat =
          subCat2 === 0
            ? $("#nonBookSubCategoryMassal option:selected").text()
            : $("#nonBookSub2CategoryMassal option:selected").text();

        if (this.choosedProducts.length) {
          this.$swal
            .fire({
              title: `<span style="font-size:20px;">Anda yakin?</span>`,
              html: `Anda memilih kategori lama <strong>"${textChoosenOldCat}" dan anda memilih ${this.choosedProducts.length} produk </strong> 
                  ke kategori baru <strong>"${textChoosenNewCat}"</strong> ?`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#C8CBCF",
              confirmButtonText: "Ya",
              cancelButtonText: "Tidak",
            })
            .then((result) => {
              if (result.isConfirmed) {
                axios
                  .put("seller/product/bulkCategory", {
                    choosedProducts: this.choosedProducts,
                    newCategoryId: valNewCat,
                  })
                  .then((res) => {
                    if (res.data.status.code !== 200) {
                      this.$toast.error(res.data.status.message);
                    } else {
                      this.$toast.success(res.data.status.message);
                      console.log(res);
                      this.categoryFilter = "";
                    }
                  })
                  .then(() => {
                    this.getAndPutResult(1);
                  });
              }
            });
        } else {
          this.$toast.error("Anda harus memilih produk yang ingin di update");
        }
      }
    },
    getAndPutResult(page) {
      $("table").addClass("table-loading");
      const oldCatCondition = $("#categoryFilter option:selected").val();
      const params = `?page=${page}&limit=${this.limitFilter}&filter_category=${
        this.categoryFilter
      }&filter_status=${this.statusFilter}&filter_keyword=${
        this.jenisCari
      }&keyword=${this.keyFilter}&sort=${this.currentSort +
        this.centerOfFilter +
        this.currentSortDir}&search=${this.searchGlobal}&filter_category_old=${
        oldCatCondition == "" || oldCatCondition != 0 ? "" : this.selectedOldCat
      } `;
      let productUrl = `seller/product${params}`;
      //GET PRODUCT
      axios
        .get(productUrl)
        .then((response) => {
          this.currentPage = response.data.data.currentPage;
          return response.data;
        })
        .then(sleeper(200))
        .then((data) => {
          $("#table-placeholder").hide();
          $("table").removeClass("table-loading");
          setTimeout(() => {
            $(".placeholder-item").removeClass("placeholder-item");
          }, 1000);
          $("table").removeClass("table-loader");
          this.column = data.data.column;
          this.products = [data][0].data;
          this.productsPagination = {
            current_page: page,
            data: [data][0].data,
            from: data.data.from,
            last_page: data.data.lastPage,
            next_page_url: data.data.nextPage,
            per_page: data.data.perPage,
            prev_page_url: page > 1 ? `${productUrl}` : null,
            to: data.data.to,
            total: data.data.total,
          };
          this.keyword = data.data.filters[0].items;
          this.category = data.data.filters[1].items;
          this.status = data.data.filters[2].items;
          this.oldCategories = data.data.filters[3].items;
        })
        .then(() => {
          this.$router
            .push({ path: "product", query: { page: page } })
            .catch(() => {
              return false;
            });
          $(".toggle_table").bootstrapToggle();
          imagePopup();
          Vue.component("vue-select", VueSelect);
        });
    },
    onPaginate(page) {
      this.getAndPutResult(page);
    },
    deleteProduct(id, name) {
      this.$swal
        .fire({
          title: "Anda Yakin?",
          text: `Ingin menghapus produk ${name} ?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, hapus!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let timerInterval = timerInterval;
            this.$swal.fire({
              title: "Sedang diproses",
              html: "Mohon Tunggu!",
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: 350,
              didOpen: () => {
                this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            axios.delete(`seller/product/${id}`).then(() => {
              this.$swal.close();
              this.getAndPutResult(1);
              this.$toast.success("Produk berhasil terhapus");
            });
          }
        });
    },
    resetFilter() {
      this.getAndPutResult(1);
      Object.assign(
        (this.currentPage = 1),
        (this.limitFilter = 5),
        (this.statusFilter = ""),
        (this.categoryFilter = ""),
        (this.jenisCari = ""),
        (this.keyFilter = ""),
        (this.currentSort = ""),
        (this.currentSortDir = ""),
        (this.searchGlobal = "")
      );
      $("#resetIcon").addClass("spin");
      setTimeout(function() {
        $("#resetIcon").removeClass("spin");
      }, 500);
    },
    sort(colValue) {
      // if you click the same label twice
      $("#filterSort").trigger("click");
      if (this.currentSort === colValue) {
        this.centerOfFilter = "-";
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else {
        $("#filterSort").trigger("click");
        this.currentSort = colValue;
      }
    },
    openModalPicture(product) {
      // const productId = product.productId;
      // const modalTitle = product.productName;
      const modalPicture = product.image;
      // console.log(modalPicture);
      // $('#imagePopup .modal-title').text(modalTitle);
      $("#imagePopup .modal-body").html(
        `<img src="${modalPicture}"` + "class='clicked' >"
      );
      $("#imagePopup").modal("toggle");
      $("#imagePopup .modal-content").css("background-color", "transparent");
      $("#imagePopup .modal-header").css("background-color", "transparent");
      $("#imagePopup .close").css("color", "white");
    },
    detailModalOpen(products) {
      // const clickedRow = table.row($(this).closest('tr'));
      const modalTitle = products.name;
      // const productId = product.productName;
      const productImage = products.image;
      const priceData = products.price;
      //zone price
      const zonePrice1 = products.priceZone1;
      const zonePrice2 = products.priceZone2;
      const zonePrice3 = products.priceZone3;
      const zonePrice4 = products.priceZone4;
      const zonePrice5 = products.priceZone5;
      //zone price
      // const productLayout = products.productLayout;

      // const productType = products.productType;
      // const productDesc = products.productDesc;
      // const openEnderContent = productDesc;
      const productModel = products.model;
      const produckQty = products.stock;
      const brandName = products.brandName;
      const categoryName = products.category;

      let imageArrayUrl = "seller/product/" + products.id;
      // console.log(imageArrayUrl)

      axios
        .get(imageArrayUrl)
        .then((response) => {
          // console.log(response)
          // console.log(response.data.data.sectionMediaInformation.imageOther);
          return response.data.data;
        })
        .then((data) => {
          let imageObj = data.sectionMediaInformation.imageOther;
          let result = "";
          imageObj.forEach((element) => {
            // console.log(element)
            result += `<div class="item-gallery"> <img src="${element.image}"> </div>`;
          });
          $("#imageArray").html(result);
        });

      $("#detailModalLabel").text(modalTitle);
      $("#productName").text(modalTitle);

      $("#priceZone").html(`
            <div class="col-sm-3"><p>Harga 1 </p> <p>${zonePrice1}</p></div> 
            <div class="col-sm-3"><p>Harga 2</p> <p>${zonePrice2}</p></div> 
            <div class="col-sm-3"><p>Harga 3</p> <p>${zonePrice3}</p></div> 
            <div class="col-sm-3"><p>Harga 4</p> <p>${zonePrice4}</p></div> 
            <div class="col-sm-3"><p>Harga 5</p> <p>${zonePrice5}</p></div>`);

      $("#productPrice").text(priceData);
      $("#productModel").text(productModel);
      $("#produckQty").text(produckQty);
      $("#brandName").text(brandName);
      $("#categoryName").text(categoryName);
      // $("#productType").text(`/${productType}`);
      // $("#productDesc").html($("<div/>", { html: openEnderContent }).text());
      // {{asset('upload/mall/image')}}/
      // https://cdn.eurekabookhouse.co.id/ebh/product/all/
      $("#imageDetail").html(`<img src="${productImage}" class='' >`);
    },
    arrowChanger() {
      if (this.arrow === 0) {
        this.arrow = 1;
        $("#filterCollapse").addClass("active");
      } else {
        this.arrow = 0;
        $("#filterCollapse").addClass("");
      }
    },
    //UNTUK KATEGORI
    filterCatNonBook(listCat) {
      return listCat.id != 22 && listCat.id != 23;
    },
    getBarangCategory() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          let catList = data.data.data[0].submenu.menu;
          this.listCategory = catList.filter(this.filterCatNonBook);
          // this.listCategory = data.data.data[0].submenu.menu;
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
        });
    },
    getCategoryVal() {
      $("#nonBookSubCategory").addClass("is-invalid");
      $("#nonBookSub2Category").addClass("d-none");
      $("#loadingCategory1").removeClass("d-none");
      var index = $("#nonBookCategory").prop("selectedIndex");
      if (index > 2) {
        this.catVal = index + 2;
      } else {
        this.catVal = index;
      }

      this.subCatVal = 0;
      $("#nonBookCategory").removeClass("is-invalid");
      $("#resultBarangCategory").html(
        `<span class="text-danger">Pilih Kategori</span>`
      );
      if ($("#nonBookSubCategory").hasClass("is-invalid")) {
        $("#resultBarangCategory").html(
          `<span class="text-danger">Pilih Kategori</span>`
        );
      }
      this.disabledEditCategoryNonBook = true;
    },
    getSubCategory() {
      this.subCatVal = 0;
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
          $("#loadingCategory1").addClass("d-none");
          $("#nonBookSubCategory").removeClass("d-none");
        });
    },
    getSubCategoryVal() {
      let textSelect = $("#nonBookSubCategory option:selected").text();
      // let valSelect = $("#nonBookSubCategory").val();
      $("#loadingCategory2").removeClass("d-none");
      $("#nonBookSub2Category").addClass("d-none");
      var index = $("#nonBookSubCategory").prop("selectedIndex");
      this.subCatVal = index;
      $("#nonBookSubCategory").removeClass("is-invalid");
      $("#nonBookSub2Category").addClass("is-invalid");
      this.disabledEditCategoryNonBook =
        this.listSub2Category.length === 0 ? false : true;
      $("#resultBarangCategory").html(
        `<span class="text-dark"><strong>${textSelect}</strong></span>`
      );
    },
    getSub2Category() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSub2Category =
            data.data.data[0].submenu.menu[this.catVal].submenu[
              this.subCatVal
            ].submenu;
          $("#loadingCategory2").addClass("d-none");
          $("#nonBookSub2Category").removeClass("d-none");
        });
    },
    lastCategoryBarang() {
      let textSelect = $("#nonBookSub2Category option:selected").text();
      // let valSelect = $("#nonBookSub2Category").val();
      $("#nonBookSub2Category").removeClass("is-invalid");
      this.disabledEditCategoryNonBook = $("#nonBookSub2Category").hasClass(
        "is-invalid"
      );
      setTimeout(() => {
        $("#resultBarangCategory").html(
          `<span class="text-dark"><strong>${textSelect}</strong></span>`
        );
      }, 660);
    },
    // di bawah ini buat list kategori jasa
    getJasaCategory() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listCategoryJasa = data.data.data[1].submenu.menu;
          this.listSubCategoryJasa =
            data.data.data[1].submenu.menu[this.catValJasa].submenu;
        });
    },
    getCategoryValJasa() {
      var e = $("#jasaCategory").prop("selectedIndex");
      this.catValJasa = e;
      $("#jasaSubCategory").addClass("is-invalid");
    },
    getSubCategoryJasa() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategoryJasa =
            data.data.data[1].submenu.menu[this.catValJasa].submenu;
        });
    },
    lastCategoryJasa() {
      let textSelect = $("#jasaSubCategory option:selected").text();
      // let valSelect = $("#jasaSubCategory").val();
      $("#resultJasaCategory").html(
        `<span class="text-dark"><strong>${textSelect}</strong></span>`
      );
      $("#jasaSubCategory").removeClass("is-invalid");
    },
    smoothScroll() {
      document.querySelector(".content").scrollIntoView({
        behavior: "smooth",
      });
    },
    resetForm() {
      this.renderComponent = false;
      this.selectedOldCat = "";
      this.$nextTick(() => {
        setTimeout(() => {
          $("#btnUpdate").prop("disabled", "disabled");
          $("#btnUpdate").removeClass("btn-primary");
        }, 200);
        this.getAndPutResult(1);
        // Add the component back in
        this.renderComponent = true;
      });
    },
  },
};
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  background: #bebebe;
  transition: opacity 0.6s ease;
}

.component-fade-enter,
.component-fade-leave-active {
  background: #fff;
  opacity: 0;
}
.bg-secondary {
  background: #c7c7c7 !important;
}
.select-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 12px;
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png)
    no-repeat right #ddd;
  background-size: 13px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #818181;
  color: #464545;
  padding: 0px 0px 0px 30px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

/* For IE <= 11 */
.select-filter::-ms-expand {
  display: none;
}

select option {
  /* margin: 40px; */
  background-color: #fff;
  color: #fff;
  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4); */
}

.select-filter-icon {
  position: absolute;
  top: 8px;
  left: 10px;
  width: 30px;
  height: 36px;
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.select-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.input-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 0.3px solid #818181;
  /* color: #464545; */
  padding: 0px 0px 0px 40px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

.input-filter::-ms-expand {
  display: none;
}

.input-filter-icon {
  position: absolute;
  top: 5px;
  left: 20px;
  width: 80%;
  /* height: 36px; */
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.input-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.select-filter:hover ~ .select-filter-icon svg.icon,
.select-filter:focus ~ .select-filter-icon svg.icon {
  fill: #464545;
}
</style>
